import { PropertyAnnotation } from '../data-described/property-annotation.model';
import { UntypedFormControl }        from '@angular/forms';
import { WidgetLayout }       from './widget-layout.model';


export class WidgetInfo<T> {

	layout: WidgetLayout;
	propertyAnnotation: PropertyAnnotation<T>;
	control: UntypedFormControl;
	include = true;

	/**
		* Visibility map for nested form fields (e.g., list-fields-form columns)
		* Key: child field name, Value: visibility state
		*/
	nestedVisibility?: Map<string, boolean>;

	constructor(propertyAnnotation: PropertyAnnotation<T>, formControl: UntypedFormControl) {
		this.propertyAnnotation = propertyAnnotation;
		this.control            = formControl;
	}
}
